/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuFilterLocation_itemSearch$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuFilterLocation_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilterLocation_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a46157a0cbf340c819532f17e011435a';
export default node;
